import axios from 'axios';
import queryString from 'query-string';
import { mt5accountsPlatformSlugs, mt5positionStatuses } from 'common/constants/accounts';

export const getPartnershipClientsBalance = () => axios.get('/partnership/balance/');

export const getUserTagsClient = userId => axios.get(`/partnership/user/${userId}/tags/`);
export const requestPartnership = referType => axios.post(`/partnership/request/${referType}`);
export const getPartnershipInfo = referType => axios.get(`/partnership/info/${referType}`);
export const getPartnershipClients = (search, referType) =>
  axios.get(`/partnership/clients/${referType}`, { params: { ...search } });
export const getUserPartnershipClients = (id, size) => axios.get(`/partnership/clients/${id}/?page_size=${size}`);

export const getPartnershipClientAccounts = id => axios.get(`/partnership/user/${id}/account/`);
export const getPartnershipClientAccount = (id, accountId) =>
  axios.get(`/partnership/user/${id}/account/${accountId}/`);
export const getPartnershipClientTrades = (id, accountId, status = 'open', start, end, accountPlatformSlug) => {
  if (mt5accountsPlatformSlugs.includes(accountPlatformSlug) && mt5positionStatuses.includes(status)) {
    const dateParams = status !== 'open' ? { start, end } : {};

    return axios.get(`/partnership/user/${id}/account/${accountId}/position/list/${status}/`, {
      params: dateParams,
    });
  }

  return axios.get(`/partnership/user/${id}/account/${accountId}/${status}_trades/`, {
    params: start && end ? { start, end } : undefined,
  });
};

export const getCurrentIBPrograms = () => axios.get(`/partnership/systems/current_ib/`);
export const getTopDownDistributionPlan = partnerAccountId =>
  axios.get(`/partnership/systems/account/${partnerAccountId}/top_down_plan/`);
export const updateTopDownDistributionPlan = (partnerAccountId, plan) =>
  axios.put(`/partnership/systems/account/${partnerAccountId}/top_down_plan/`, plan);
export const updateTopDownPolicy = (partnerAccountId, policy) =>
  axios.put(`/partnership/systems/account/${partnerAccountId}/top_down_plan/policy/`, policy);
export const previewTopDownPolicy = (partnerAccountId, policy) =>
  axios.post(`/partnership/systems/account/${partnerAccountId}/top_down_preview/`, policy);
export const getTopDownAllocations = (partnerAccountId, params) =>
  axios.get(`/partnership/systems/account/${partnerAccountId}/top_down_allocations/`, params ? { params } : undefined);
export const getSimpleIBSystemSettings = () => axios.get(`/partnership/systems/simple_conditions_settings/`);
export const sendSimpleIBSystemSettings = settings =>
  axios.post(`/partnership/systems/simple_conditions_settings/`, { ...settings });

export const getPartnershipMaterials = (type, search) =>
  axios.get(`/partnership/materials/${type}/list/?${queryString.stringify(search)}`);

export const getPartnershipWithdrawalAccounts = partnerAccountId =>
  axios.get(`/partnership/systems/account/${partnerAccountId}/withdraw/`);
export const withdrawPartnershipAccount = (partnerAccountId, accountId, toWallet) =>
  axios.post(`/partnership/systems/account/${partnerAccountId}/withdraw/`, { accountId, toWallet });
export const requestEasyStart = referType => axios.post(`/partnership/systems/easy_start/`, { referType });

export const changeRebate = (accountId, rebate) =>
  axios.put(`partnership/systems/account/${accountId}/change_rebate/`, { rebate });

export const getCampaigns = () => axios.get(`/partnership/materials/campaigns/list/`);

export const createBanners = data => axios.post(`/partnership/materials/banners_set/create/`, { ...data });

export const getPartnershipWithdrawalWalletAccounts = partnerAccountId =>
  axios.get(`/partnership/systems/account/${partnerAccountId}/withdraw/wallet_account/`);
export const withdrawPartnershipWalletAccount = (partnerAccountId, accountId) =>
  axios.post(`/partnership/systems/account/${partnerAccountId}/withdraw/wallet_account/`, { accountId });
